import { FC } from 'react';
import { Checkbox } from '../../../checkbox/Checkbox';
import { SeriesCheckboxLabel } from '../../composite-chart/series-checkbox-label/SeriesCheckboxLabel';
import { Group, Stack } from '@mantine/core';

import styles from './ChartToggle.module.css';

import { joinClassNames } from '../../../../utils/joinClassNames';

export type CompositeChartToggleProps = {
    series: Array<{ name: string; color?: string; selected: boolean }>;
    withCumulative?: boolean;
    onSeriesToggle: (args: { checked: boolean; index: number; name: string }) => void;
    onCumulativeToggle?: (checked: boolean) => void;
    cumulativeLabel?: string;
    className?: string;
};

export const CompositeChartToggle: FC<CompositeChartToggleProps> = ({
    series,
    withCumulative,
    onSeriesToggle,
    onCumulativeToggle,
    className,
    cumulativeLabel,
}) => {
    return (
        <Group className={joinClassNames(styles.root, className)}>
            <Group className={styles.seriesGroup}>
                {series.map((item, index) => (
                    <Checkbox
                        key={item.name}
                        label={<SeriesCheckboxLabel color={item.color || 'blue'} name={item.name} />}
                        checked={item.selected}
                        onChange={event =>
                            onSeriesToggle({
                                checked: event.currentTarget.checked,
                                index,
                                name: item.name,
                            })
                        }
                    />
                ))}
            </Group>
            {withCumulative && (
                <Stack className={styles.cumulativeGroup}>
                    <Checkbox
                        label={cumulativeLabel ?? 'Cumulative Chart View'}
                        onChange={e => onCumulativeToggle?.(e.currentTarget.checked)}
                    />
                </Stack>
            )}
        </Group>
    );
};
